import type { Palette, Theme } from '@mui/material/styles';

/**
 * @deprecated Use `getToken` instead wherever possible, with `getCssVar` being the next best option.
 * @param theme
 */
export function getThemePalette<T extends Theme>(
  theme: T
): Palette | T['vars']['palette'] {
  return (theme.vars ?? theme).palette;
}
